import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=f583ab4c&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"
import style0 from "./AboutModal.vue?vue&type=style&index=0&id=f583ab4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f583ab4c",
  null
  
)

export default component.exports